import axios from 'axios';
import api from '..';

export const createUUID = (number) => {
  return axios.get(`https://www.uuidgenerator.net/api/version4${number ? `/${number}` : ''}`);
};

export const createBrand = (body, auth, setAuth) => {
  return api.post(`/brands`, body, auth, setAuth);
};

export const createGallery = (body, auth, setAuth) => {
  return api.post(`/galleries`, body, auth, setAuth);
};

export const createQRCode = (body, auth, setAuth) => {
  return api.post(`/qr_codes`, body, auth, setAuth);
};

export const createGalleryAllowedQRCode = (body, auth, setAuth) => {
  return api.post(`/gallery_allowed_qr_codes`, body, auth, setAuth);
};

export const createFile = (body, auth, setAuth) => {
  return api.post(`/files`, body, auth, setAuth);
};

export const createCompetitionClothingTemplate = (body, auth, setAuth) => {
  return api.post(`/competition_clothing_templates`, body, auth, setAuth);
};

export const importQrCodeImage = (body, auth, setAuth) => {
  return api.postFormData(`/import_qr_code_image`, body, auth, setAuth);
};

export const importQrCodeId = (body, auth, setAuth) => {
  return api.postFormData(`/import_qr_code_id`, body, auth, setAuth);
};

export const importNewUser = (body, auth, setAuth) => {
  return api.postFormData(`/import_users`, body, auth, setAuth);
};